import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';

import { Subscription } from 'rxjs';

import { PreviewService } from '../../../../../services/preview/preview.service';
import { ModuleItemAttribute, ModuleItemAvailableAttribute } from '../../../../../../models/module-item-attribute';
import { selectSelectedLanguage } from '../../../../../state/study/study.selectors';
import { AppState } from '../../../../../../state';
import { Language } from '../../../../../../models/language';

@Component({
  selector: 'dashboard-network-config-preview',
  templateUrl: './network-config-preview.component.html',
  styleUrls: ['./network-config-preview.component.scss'],
})
export class NetworkConfigPreviewComponent implements OnInit, OnDestroy {
  @Input() initialAttributes: ModuleItemAttribute[];

  selectedLanguage: Language;

  previewSliderLabel: string;
  previewLabelLeft: string;
  previewLabelRight: string;

  private subscriptions = new Subscription();

  constructor(private previewService: PreviewService, private store: Store<AppState>) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.store.select(selectSelectedLanguage).subscribe((selectedLanguage) => {
        this.selectedLanguage = selectedLanguage;
      })
    );

    this.previewSliderLabel =
      this.initialAttributes
        ?.find((attribute) => attribute.attribute === ModuleItemAvailableAttribute.SLIDER_LABEL)
        ?.translations?.filter((translation) => translation?.language === this.selectedLanguage.code)[0]?.translation ||
      '';

    this.previewLabelLeft =
      this.initialAttributes
        ?.find((attribute) => attribute.attribute === ModuleItemAvailableAttribute.LABEL_LEFT)
        ?.translations?.filter((translation) => translation?.language === this.selectedLanguage.code)[0]?.translation ||
      '';

    this.previewLabelRight =
      this.initialAttributes
        ?.find((attribute) => attribute.attribute === ModuleItemAvailableAttribute.LABEL_RIGHT)
        ?.translations?.filter((translation) => translation?.language === this.selectedLanguage.code)[0]?.translation ||
      '';

    this.subscriptions.add(
      this.previewService.previewData$.subscribe((previewData) => {
        if (previewData?.sliderLabel) {
          this.previewSliderLabel = previewData?.sliderLabel;
        }
        if (previewData?.labelLeft) {
          this.previewLabelLeft = previewData?.labelLeft;
        }
        if (previewData?.labelRight) {
          this.previewLabelRight = previewData?.labelRight;
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
